module.exports = __webpack_public_path__ + "img/l-cb6-101.bdd175cc.gif";